export enum ProductsPages {
  DOCUMENTS = 'documents',
  PRODUCTS = 'products',
}
